/* eslint-disable */

import { useEffect, useState } from "react";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  useNavigate,
} from "react-router-dom";

import { computeNewValuesOnAdd, stringifyWithoutQuotes } from "./logic/logic";
import { fetchGraphQL } from "./services/api-raindrop";
import {
  MAX_NUMBER_OF_ORGANISATIONS_EMERALD,
  MAX_NUMBER_OF_ORGANISATIONS_SAPPHIRE,
  RAINDROP_SESSION_TOKEN_KEY,
} from "./services/constants";
import {
  getRaindropEnvironment,
  isDomainCirrus,
  isDomainNimbus,
  isDomainRaindrop,
  isDomainStratus,
  isLocalEnvironment,
} from "./services/environment";

import { Navigate } from "react-router-dom";

import NimbusBase from "./ui-pages/nimbus/nimbus-base/nimbus-base.tsx";
import NimbusCronJobsIndex from "./ui-pages/nimbus/nimbus-cron-jobs-index/nimbus-cron-jobs-index.tsx";
import NimbusDeveloperToolsAPIHitters from "./ui-pages/nimbus/nimbus-developer-tools-api-hitters/nimbus-developer-tools-api-hitters.tsx";
import NimbusDeveloperToolsDatabase from "./ui-pages/nimbus/nimbus-developer-tools-database/nimbus-developer-tools-database.tsx";
import NimbusDeveloperToolsIndex from "./ui-pages/nimbus/nimbus-developer-tools-index/nimbus-developer-tools-index.tsx";
import NimbusFinanceIndex from "./ui-pages/nimbus/nimbus-finance-index/nimbus-finance-index.tsx";
import NimbusFinanceStripePricing from "./ui-pages/nimbus/nimbus-finance-stripe-pricing/nimbus-finance-stripe-pricing.tsx";
import NimbusHome from "./ui-pages/nimbus/nimbus-home/nimbus-home.tsx";
import NimbusIncidentsIndex from "./ui-pages/nimbus/nimbus-incidents-index/nimbus-incidents-index.tsx";
import NimbusIncidentsInstance from "./ui-pages/nimbus/nimbus-incidents-instance/nimbus-incidents-instance.tsx";
import NimbusIncidentsSearch from "./ui-pages/nimbus/nimbus-incidents-search/nimbus-incidents-search.tsx";
import NimbusNotFound from "./ui-pages/nimbus/nimbus-not-found/nimbus-not-found.tsx";
import NimbusOrganisationsIndex from "./ui-pages/nimbus/nimbus-organisations-index/nimbus-organisations-index.tsx";
import NimbusOrganisationsInstance from "./ui-pages/nimbus/nimbus-organisations-instance/nimbus-organisations-instance.tsx";
import NimbusOrganisationsNew from "./ui-pages/nimbus/nimbus-organisations-new/nimbus-organisations-new.tsx";
import NimbusOrganisationsSearch from "./ui-pages/nimbus/nimbus-organisations-search/nimbus-organisations-search.tsx";
import NimbusSharecardsNew from "./ui-pages/nimbus/nimbus-sharecards-new/nimbus-sharecards-new.tsx";
import NimbusTeamsIndex from "./ui-pages/nimbus/nimbus-teams-index/nimbus-teams-index.tsx";
import NimbusTeamsInstance from "./ui-pages/nimbus/nimbus-teams-instance/nimbus-teams-instance.tsx";
import NimbusTeamsReview from "./ui-pages/nimbus/nimbus-teams-review/nimbus-teams-review.tsx";
import NimbusUsersIndex from "./ui-pages/nimbus/nimbus-users-index/nimbus-users-index.tsx";
import NimbusUsersInstance from "./ui-pages/nimbus/nimbus-users-instance/nimbus-users-instance.tsx";
import NimbusUsersSearch from "./ui-pages/nimbus/nimbus-users-search/nimbus-users-search.tsx";

import RaindropActivity from "./ui-pages/raindrop/raindrop-activity/raindrop-activity.tsx";
import RaindropAuthenticate from "./ui-pages/raindrop/raindrop-authenticate/raindrop-authenticate.tsx";
import RaindropBaseAuthenticated from "./ui-pages/raindrop/raindrop-base-authenticated/raindrop-base-authenticated.tsx";
import RaindropBase from "./ui-pages/raindrop/raindrop-base/raindrop-base.tsx";
import RaindropPaymentMethodAdd from "./ui-pages/raindrop/raindrop-payment-method-add/raindrop-payment-method-add.tsx";
import RaindropEntry from "./ui-pages/raindrop/raindrop-entry/raindrop-entry.tsx";
import RaindropHome from "./ui-pages/raindrop/raindrop-contribution/raindrop-contribution.tsx";
import RaindropKindness from "./ui-pages/raindrop/raindrop-kindness/raindrop-kindness.tsx";
import RaindropLegalPrivacyPolicy from "./ui-pages/raindrop/raindrop-legal-privacy-policy/raindrop-legal-privacy-policy.tsx";
import RaindropLegalTermsAndConditions from "./ui-pages/raindrop/raindrop-legal-terms-and-conditons/raindrop-legal-terms-and-conditions.tsx";
import RaindropLogin from "./ui-pages/raindrop/raindrop-login/raindrop-login.tsx";
import RaindropOnboarding from "./ui-pages/raindrop/raindrop-onboarding/raindrop-onboarding.tsx";
import RaindropOrganisation from "./ui-pages/raindrop/raindrop-organisation/raindrop-organisation.tsx";
import RaindropPayments from "./ui-pages/raindrop/raindrop-payments/raindrop-payments.tsx";
import RaindropPlayground from "./ui-pages/raindrop/raindrop-playground/raindrop-playground.tsx";
import RaindropSearch from "./ui-pages/raindrop/raindrop-search/raindrop-search.tsx";
import RaindropContributions from "./ui-pages/raindrop/raindrop-settings-contributions/raindrop-settings-contributions.tsx";
import RaindropSettingsLanguage from "./ui-pages/raindrop/raindrop-settings-language/raindrop-settings-language.tsx";
import RaindropSettingsLegal from "./ui-pages/raindrop/raindrop-settings-legal/raindrop-settings-legal.tsx";
import RaindropSettingsPaymentMethods from "./ui-pages/raindrop/raindrop-settings-payment-methods/raindrop-settings-payment-methods.tsx";
import RaindropSettingsQuestions from "./ui-pages/raindrop/raindrop-settings-questions/raindrop-settings-questions.tsx";
import RaindropSettings from "./ui-pages/raindrop/raindrop-settings/raindrop-settings.tsx";
import RaindropWelcome from "./ui-pages/raindrop/raindrop-welcome/raindrop-welcome.tsx";

import StratusBase from "./ui-pages/stratus/stratus-base/stratus-base.tsx";
import StratusHome from "./ui-pages/stratus/stratus-home/stratus-home.tsx";
import StratusNotFound from "./ui-pages/stratus/stratus-not-found/stratus-not-found.tsx";
import StratusRequestDemo from "./ui-pages/stratus/stratus-request-demo/stratus-request-demo.tsx";
import RaindropSignUp from "./ui-pages/raindrop/raindrop-sign-up/raindrop-sign-up.tsx";
import NimbusDeveloperToolsEmails from "./ui-pages/nimbus/nimbus-developer-tools-emails/nimbus-developer-tools-emails.tsx";
import NimbusLogin from "./ui-pages/nimbus/nimbus-login/nimbus-login.tsx";
import NimbusBaseAuthenticated from "./ui-pages/nimbus/nimbus-base-authenticated/nimbus-base-authenticated.tsx";
import CirrusBase from "./ui-pages/cirrus/cirrus-base/cirrus-base.tsx";
import CirrusBaseAuthenticated from "./ui-pages/cirrus/cirrus-base-authenticated/cirrus-base-authenticated.tsx";
import CirrusHome from "./ui-pages/cirrus/cirrus-home/cirrus-home.tsx";
import CirrusActivityNew from "./ui-pages/cirrus/cirrus-activity-new/cirrus-activity-new.tsx";
import NimbusAuthenticate from "./ui-pages/nimbus/nimbus-authenticate/nimbus-authenticate.tsx";
import CirrusLogin from "./ui-pages/cirrus/cirrus-login/cirrus-login.tsx";
import CirrusAuthenticate from "./ui-pages/cirrus/cirrus-authenticate/cirrus-authenticate.tsx";
import CirrusRegisterOrganisation from "./ui-pages/cirrus/cirrus-register-organisation/cirrus-register-organisation.tsx";
import CirrusEntry from "./ui-pages/cirrus/cirrus-entry/cirrus-entry.tsx";
import CirrusSignUp from "./ui-pages/cirrus/cirrus-sign-up/cirrus-sign-up.tsx";
import CirrusSettings from "./ui-pages/cirrus/cirrus-settings/cirrus-settings.tsx";
import CirrusBaseAnonymous from "./ui-pages/cirrus/cirrus-base-anonymous/cirrus-base-anonymous.tsx";
import RaindropBaseTabBar from "./ui-pages/raindrop/raindrop-base-tab-bar/raindrop-base-tab-bar.tsx";
import RaindropContributionInstance from "./ui-pages/raindrop/raindrop-contribution-instance/raindrop-contribution-instance.tsx";
import StratusAboutUs from "./ui-pages/stratus/stratus-about-us/stratus-about-us.tsx";
import StratusContactUs from "./ui-pages/stratus/stratus-contact-us/stratus-contact-us.tsx";
import NimbusDeveloperToolsOneOffScripts from "./ui-pages/nimbus/nimbus-developer-tools-one-off-scripts/nimbus-developer-tools-one-off-scripts.tsx";
import StratusOrganisation from "./ui-pages/stratus/stratus-organisation-info/stratus-organisation-info.tsx";
import RaindropFeedback from "./ui-pages/raindrop/raindrop-feedback/raindrop-feedback.tsx";
import CirrusDonations from "./ui-pages/cirrus/cirrus-donations/cirrus-donations.tsx";
import CirrusFeedback from "./ui-pages/cirrus/cirrus-feedback/cirrus-feedback.tsx";
import NimbusOrganisationUserSearch from "./ui-pages/nimbus/nimbus-organisation-user-search /nimbus-organisation-user-search.tsx";

import RaindropWaterfallCreate from "./ui-pages/raindrop/raindrop-waterfall-create/raindrop-waterfall-create.tsx";
import RaindropWaterfall from "./ui-pages/raindrop/raindrop-waterfall/raindrop-waterfall.tsx";
import RaindropWaterfallPostCreate from "./ui-pages/raindrop/raindrop-waterfall-post-create/raindrop-waterfall-post-create.tsx";
import RaindropAccount from "./ui-pages/raindrop/raindrop-account/raindrop-account.tsx";
import RaindropAccountNewProfile from "./ui-pages/raindrop/raindrop-account-new-profile.tsx/raindrop-account-new-profile.tsx";
import RaindropTipAddToHome from "./ui-pages/raindrop/raindrop-settings-add-to-home-screen/raindrop-settings-add-to-home-screen.tsx";
import RaindropAccountFollowers from "./ui-pages/raindrop/raindrop-account-followers/raindrop-account-followers.tsx";
import RaindropAccountFollowing from "./ui-pages/raindrop/raindrop-account-following/raindrop-account-following.tsx";
import StratusFrequentlyAskedQuestions from "./ui-pages/stratus/stratus-frequently-asked-questions/stratus-frequently-asked-questions.tsx";
import StratusTermsAndConditions from "./ui-pages/stratus/stratus-terms-and-conditions/stratus-terms-and-conditions.tsx";
import StratusPrivacyPolicy from "./ui-pages/stratus/stratus-privacy-policy/stratus-privacy-policy.tsx";
import CirrusAdvertisementCreate from "./ui-pages/cirrus/cirrus-advertisement-create/cirrus-advertisement-create.tsx";
import RaindropPasswordReset from "./ui-pages/raindrop/raindrop-password-reset/raindrop-password-reset.tsx";
import { Orientation, SausageStyleColor, Size } from "./logic/enums.ts";
import StratusBlog from "./ui-pages/stratus/stratus-blog/stratus-blog.tsx";
import RaindropMeditation from "./ui-pages/raindrop/raindrop-meditation/raindrop-meditation.tsx";
import RaindropBuyCoffee from "./ui-pages/raindrop/raindrop-buy-coffee/raindrop-buy-coffee.tsx";
import CirrusDescription from "./ui-pages/cirrus/cirrus-description/cirrus-description.tsx";
import RaindropDating from "./ui-pages/raindrop/raindrop-dating/raindrop-dating.tsx";
import RaindropUpdateAmount from "./ui-pages/raindrop/raindrop-update-amount/raindrop-update-amount.tsx";
import CirrusActivity from "./ui-pages/cirrus/cirrus-activity/cirrus-activity.tsx";
import CirrusAdvertisements from "./ui-pages/cirrus/cirrus-advertisements/cirrus-advertisements.tsx";
import RaindropNotifications from "./ui-pages/raindrop/raindrop-notifications/raindrop-notifications.tsx";
import RaindropSettingsNotifications from "./ui-pages/raindrop/raindrop-settings-notifications/raindrop-settings-notifications.tsx";
import RaindropPomodoro from "./ui-pages/raindrop/raindrop-pomodoro/raindrop-pomodoro.tsx";
import NimbusResetPassword from "./ui-pages/nimbus/nimbus-reset-password/nimbus-reset-password.tsx";

import RaindropTour from "./ui-pages/raindrop/raindrop-tour/raindrop-tour.tsx";
import RaindropBombshell from "./ui-pages/raindrop/raindrop-bombshell/raindrop-bombshell.tsx";
import RaindropBaseShare from "./ui-pages/raindrop/raindrop-base-share/raindrop-base-share.tsx";
import RaindropPlus from "./ui-pages/raindrop/raindrop-plus/raindrop-plus.tsx";
import NimbusQuiz from "./ui-pages/nimbus/nimbus-quiz/nimbus-quiz.tsx";
import RaindropContribution from "./ui-pages/raindrop/raindrop-contribution/raindrop-contribution.tsx";
import RaindropBombsAway from "./ui-pages/raindrop/raindrop-bombsaway/raindrop-bombsaway.tsx";
import RaindropButton, {
  ButtonStyle,
} from "./ui-components/raindrop-button/raindrop-button.tsx";
import RaindropActivityComments from "./ui-pages/raindrop/raindrop-activity-comments/raindrop-activity-comments.tsx";
import RaindropNotFound from "./ui-pages/raindrop/raindrop-not-found/raindrop-not-found.tsx";
import RaindropVolunteer from "./ui-pages/raindrop/raindrop-volunteer/raindrop-volunteer.tsx";
import RaindropVolunteerInstance from "./ui-pages/raindrop/raindrop-volunteer-instance/raindrop-volunteer-instance.tsx";

const ModalMaximumCharities = ({ setCurrentModalComponent }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col max-w-sm gap-6 p-4">
      <i className="fa-solid fa-faucet-drip text-6xl "></i>
      <h4 className="font-extrabold text-3xl ">Aw, man.</h4>
      <p>You've hit the maximum number of charities to support.</p>

      <RaindropButton
        size={Size.Large}
        style={ButtonStyle.Primary}
        title="Upgrade for free"
        isFluid={true}
        onClick={() => {
          navigate("/raindrop/upgrade");
          setCurrentModalComponent(null);
        }}
      />
    </div>
  );
};

function App() {
  // Universal State
  const [orientation, setOrientation] = useState(Orientation.Portrait);

  // Layer Components
  const [currentModalComponent, setCurrentModalComponent] = useState(null);
  const [shareComponent, setShareComponent] = useState(null);

  // Raindrop Only
  const [userCurrent, setUserCurrent] = useState(null);
  const [currentKindnessAmount, setCurrentKindnessAmount] = useState(30);
  const [isFocusedOnCenter, setIsFocusedOnCenter] = useState(false);
  const isRaindropPlus = userCurrent?.account?.isRaindropPlus;
  const [sausageValues, setSausageValues] = useState([]);

  // Cirrus Only
  const [currentOrganisationUser, setCurrentOrganisationUser] = useState(null);

  // Nimbus Only
  const [currentSupportUser, setCurrentSupportUser] = useState(null);

  // To be removed
  const [isDemo, setIsDemo] = useState(getRaindropEnvironment() === "DEMO");
  const [isPaused, setIsPaused] = useState(false);

  // Constants
  const isAnonymous = userCurrent === null;

  // Helper Functions
  const onLogoutRaindrop = () => {
    localStorage.removeItem(RAINDROP_SESSION_TOKEN_KEY);
    setUserCurrent(null);
    setSausageValues([]);
  };

  const setValues = (newValues) => {
    if (newValues === sausageValues) {
      return;
    }

    let sendData = false;
    newValues.forEach((newSausage) => {
      // Find the old value
      const oldSausage = sausageValues.find((value) => {
        if (value.organisation) {
          return value.organisation.id === newSausage.organisation?.id;
        } else if (value.waterfall) {
          return value.waterfall?.id === newSausage.waterfall?.id;
        } else {
          return false;
        }
      });

      // If the value is new, we need to send the data
      if (oldSausage === undefined) {
        sendData = true;
        return;
      }

      // If the sausage is not new, but the value has changed, we need to send the data
      if (oldSausage.oldValue !== newSausage.oldValue) {
        sendData = true;
        return;
      }

      // If the color has changed, we need to send the data
      if (oldSausage?.oldColor !== newSausage.oldColor) {
        sendData = true;
        return;
      }
    });

    if (newValues.length !== sausageValues.length) {
      sendData = true;
    }

    // Set the local values
    setSausageValues(newValues);

    // If we need to send the data, send it
    if (sendData && !isAnonymous) {
      fetchGraphQL(`
        mutation {
          updateAccountPlan(
            sausages: ${stringifyWithoutQuotes(
              newValues.map((v) => ({
                organisationId: v.organisation?.id ? v.organisation?.id : null,
                waterfallId: v.waterfall?.id ? v.waterfall?.id : null,
                percentage: v.value,
                styleColor: v.color ? v.color : SausageStyleColor.Pink,
              }))
            )}
          ) {
            id
            subunits
            subunitsCurrency
            contributionDay
            isSupportingRaindrop
            isPaused
            sausages {
              id
              percentage
              styleColor
              organisation {
                id
                name
                presignedUrlLogo
                isHydrated
              }
              waterfall {
                id
                title
                organisation {
                  id
                  presignedUrlLogo
                }
                account {
                  id
                  presignedUrl
                }
              }
            }    
          }
        }
      `).then((response) => {
        if (response.errors) {
          console.error(
            "RD-009 -- Error updating account plan",
            response.errors
          );
          return;
        } else {
          const accountPlan = response.data.updateAccountPlan;

          setUserCurrent((prev) => ({
            ...prev,
            account: {
              ...prev.account,
              accountPlan: accountPlan,
            },
          }));
        }
      });
    }
  };

  const onAddNewOrganisation = ({ organisation = null, waterfall = null }) => {
    if (
      sausageValues.length === MAX_NUMBER_OF_ORGANISATIONS_EMERALD &&
      !isRaindropPlus
    ) {
      setCurrentModalComponent(
        <ModalMaximumCharities
          setCurrentModalComponent={setCurrentModalComponent}
        />
      );
      return;
    }

    if (sausageValues.length === MAX_NUMBER_OF_ORGANISATIONS_SAPPHIRE) {
      setCurrentModalComponent(
        <ModalMaximumCharities
          setCurrentModalComponent={setCurrentModalComponent}
        />
      );
      return;
    }

    const isAlreadySupporting = sausageValues.find((v) => {
      if (v.organisation) {
        return v.organisation.id === organisation?.id;
      }
      return v.waterfall.id === waterfall?.id;
    });

    if (isAlreadySupporting) {
      console.warn(
        "(RD-2346) You can't support the same organisation or waterfall twice."
      );
      return;
    }

    const newValueForOrganisation = sausageValues.length > 0 ? 10 : 100;

    const newPercentageValues = computeNewValuesOnAdd(
      sausageValues.map((v) => v.value),
      newValueForOrganisation
    );

    const newValues = [...sausageValues];

    newValues.forEach((value, i) => {
      value.value = newPercentageValues[i];
      value.oldValue = undefined;
      value.selected = false;
      value.minorSelected = false;
    });

    newValues.push({
      id: `local-temp-id-${organisation?.id}-${waterfall?.id}`,
      organisation: organisation,
      waterfall: waterfall,
      value: newValueForOrganisation,
      oldValue: newValueForOrganisation,
      selected: true,
      locked: false,
      minorSelected: false,
    });

    setValues(newValues);
  };

  const onCancelOrganisation = ({ organisation = null, waterfall = null }) => {
    if (sausageValues.length == 0) {
      return;
    }

    if (sausageValues.length == 1) {
      // TODO: Should be able to cancel just one
      return;
    }

    const percentage = sausageValues.find((v) => {
      if (v.organisation) {
        return v.organisation.id === organisation?.id;
      }
      return v.waterfall.id === waterfall?.id;
    }).value;

    const newValues = sausageValues.filter((v) => {
      if (v.organisation) {
        return v.organisation.id !== organisation?.id;
      }
      return v.waterfall.id !== waterfall?.id;
    });

    for (let i = 0; i < percentage; i++) {
      newValues[i % newValues.length].value += 1;
      newValues[i % newValues.length].oldValue += 1;
    }

    setValues(newValues);
  };

  useEffect(() => {
    if (currentKindnessAmount === 0) {
      setIsPaused(true);
    } else {
      setIsPaused(false);
    }
  }, [currentKindnessAmount]);

  useEffect(() => {
    if (userCurrent === null) {
      setSausageValues([]);
      return;
    }

    const currentPlan = userCurrent.account.accountPlan;
    if (currentPlan === null) {
      setSausageValues([]);
      return;
    }

    const newValues = currentPlan.sausages.map((sausage) => {
      const oldSausageValue = sausageValues
        ? sausageValues.find((v) => {
            if (v.organisation) {
              return v.organisation.id === sausage.organisation?.id;
            }
            if (v.waterfall) {
              return v.waterfall.id === sausage.waterfall?.id;
            }
            return false;
          })
        : null;

      return {
        ...sausage,
        id: sausage.id,
        organisation: sausage.organisation,
        waterfall: sausage.waterfall,
        value: sausage.percentage,
        oldValue: sausage.percentage,
        selected: oldSausageValue ? oldSausageValue.selected : false,
        color: sausage?.styleColor,
        oldColor: sausage?.styleColor,
      };
    });

    setSausageValues(newValues);
  }, [userCurrent]);

  const indexElementCirrus = (
    <CirrusHome currentOrganisationUser={currentOrganisationUser} />
  );

  const onResetCircle = () => {
    const newValues = [...sausageValues];
    newValues.forEach((v) => (v.selected = false));
    setValues(newValues);
  };

  // Orientation logic -- START
  useEffect(() => {
    const checkOrientation = () => {
      if (window.matchMedia("(orientation: portrait)").matches) {
        setOrientation(Orientation.Portrait);
      } else {
        setOrientation(Orientation.Landscape);
      }
    };

    checkOrientation();
    window.addEventListener("resize", checkOrientation);
    return () => {
      window.removeEventListener("resize", checkOrientation);
    };
  }, []);

  const routes = (
    <Route>
      {(isLocalEnvironment() || isDomainRaindrop()) && (
        <Route
          id={"route-raindrop"}
          element={<RaindropBase orientation={orientation} />}
        >
          <Route
            element={
              <RaindropBaseShare
                shareComponent={shareComponent}
                setShareComponent={setShareComponent}
              />
            }
          >
            <Route
              id="raindrop-authenticated"
              element={
                <RaindropBaseAuthenticated
                  userCurrent={userCurrent}
                  setUserCurrent={setUserCurrent}
                  currentModalComponent={currentModalComponent}
                  setCurrentModalComponent={setCurrentModalComponent}
                />
              }
            >
              <Route
                path="/raindrop/onboarding"
                element={
                  <RaindropOnboarding
                    userCurrent={userCurrent}
                    setUserCurrent={setUserCurrent}
                    onAddNewOrganisation={onAddNewOrganisation}
                    onCancelOrganisation={onCancelOrganisation}
                    sausageValues={sausageValues}
                    setValues={setValues}
                    setShareComponent={setShareComponent}
                    onResetCircle={onResetCircle}
                  />
                }
              />
              <Route
                path="/raindrop/bombshell"
                element={
                  <RaindropBombshell
                    userCurrent={userCurrent}
                    setUserCurrent={setUserCurrent}
                    setShareComponent={setShareComponent}
                    setIsFocusedOnCenter={setIsFocusedOnCenter}
                  />
                }
              />
              <Route
                id="tab-bar"
                element={
                  <RaindropBaseTabBar
                    userCurrent={userCurrent}
                    onResetCircle={onResetCircle}
                    orientation={orientation}
                    values={sausageValues}
                    setShareComponent={setShareComponent}
                    isFocusedOnCenter={isFocusedOnCenter}
                    isRaindropPlus={isRaindropPlus}
                  />
                }
              >
                <Route
                  path="/raindrop"
                  element={<Navigate to="/raindrop/activity" />}
                />

                <Route
                  path="/raindrop/contribution"
                  element={
                    <RaindropContribution
                      sausageValues={sausageValues}
                      setValues={setValues}
                      userCurrent={userCurrent}
                    />
                  }
                />
                <Route
                  path="/raindrop/upgrade"
                  element={
                    <RaindropPlus
                      userCurrent={userCurrent}
                      setUserCurrent={setUserCurrent}
                    />
                  }
                />
                <Route
                  path="/raindrop/meditate"
                  element={<RaindropMeditation values={sausageValues} />}
                />
                <Route
                  path="/raindrop/pomodoro"
                  element={<RaindropPomodoro values={sausageValues} />}
                />
                <Route
                  path="/raindrop/buy-coffee"
                  element={<RaindropBuyCoffee userCurrent={userCurrent} />}
                />
                <Route
                  path="/raindrop/activity"
                  element={
                    <RaindropActivity
                      userCurrent={userCurrent}
                      values={sausageValues}
                      setValues={setValues}
                      isPaused={userCurrent?.account.accountPlan?.isPaused}
                      isRaindropPlus={isRaindropPlus}
                      onAddNewOrganisation={onAddNewOrganisation}
                      onCancelOrganisation={onCancelOrganisation}
                      setCurrentModalComponent={setCurrentModalComponent}
                    />
                  }
                />
                <Route
                  path="/raindrop/volunteer"
                  element={<RaindropVolunteer />}
                />
                <Route
                  path="/raindrop/volunteer/instance"
                  element={<RaindropVolunteerInstance />}
                />

                <Route
                  path="/raindrop/activity/comments/:waterfallPostId"
                  element={
                    <RaindropActivityComments userCurrent={userCurrent} />
                  }
                />

                <Route
                  path="/raindrop/feedback"
                  element={<RaindropFeedback />}
                />

                <Route
                  path="/raindrop/organisation/:organisationId"
                  element={
                    <RaindropOrganisation
                      sausageValues={sausageValues}
                      setValues={setValues}
                      onAddNewOrganisation={onAddNewOrganisation}
                      onCancelOrganisation={onCancelOrganisation}
                      userCurrent={userCurrent}
                      setCurrentModalComponent={setCurrentModalComponent}
                    />
                  }
                />
                <Route
                  path="/raindrop/account/:accountId"
                  element={
                    <RaindropAccount
                      userCurrent={userCurrent}
                      setUserCurrent={setUserCurrent}
                    />
                  }
                />
                <Route
                  path="/raindrop/account/:accountId/followers"
                  element={
                    <RaindropAccountFollowers userCurrent={userCurrent} />
                  }
                />
                <Route
                  path="/raindrop/account/:accountId/following"
                  element={
                    <RaindropAccountFollowing userCurrent={userCurrent} />
                  }
                />
                <Route
                  path="/raindrop/account/upload-profile-picture"
                  element={
                    <RaindropAccountNewProfile userCurrent={userCurrent} />
                  }
                />

                <Route
                  path="/raindrop/search"
                  element={
                    <RaindropSearch
                      userCurrent={userCurrent}
                      values={sausageValues}
                      isPaused={userCurrent?.account?.accountPlan?.isPaused}
                      setValues={setValues}
                      isRaindropPlus={isRaindropPlus}
                      onAddNewOrganisation={onAddNewOrganisation}
                      onCancelOrganisation={onCancelOrganisation}
                    />
                  }
                />
                <Route
                  path="/raindrop/dating"
                  element={<RaindropDating userCurrent={userCurrent} />}
                />
                <Route
                  path="/raindrop/settings/contributions"
                  element={
                    <RaindropContributions
                      userCurrent={userCurrent}
                      setUserCurrent={setUserCurrent}
                      accountId={userCurrent?.account?.id}
                    />
                  }
                />
                <Route
                  path="/raindrop/settings/contribution/:accountPlanExecutionId"
                  element={
                    <RaindropContributionInstance
                      accountId={userCurrent?.account?.id}
                    />
                  }
                />
                <Route
                  path="/raindrop/settings/contributions/update-amount"
                  element={
                    <RaindropUpdateAmount
                      accountId={userCurrent?.account?.id}
                    />
                  }
                />

                <Route
                  path="/raindrop/settings/payments"
                  element={<RaindropPayments userCurrent={userCurrent} />}
                />

                <Route
                  path="/raindrop/settings/language"
                  element={<RaindropSettingsLanguage />}
                />
                <Route
                  path="/raindrop/settings/frequently-asked-questions"
                  element={<RaindropSettingsQuestions />}
                />
                <Route
                  path="/raindrop/settings/legal"
                  element={<RaindropSettingsLegal />}
                />

                <Route
                  path="/raindrop/bombsaway"
                  element={
                    <RaindropBombsAway
                      setIsFocusedOnCenter={setIsFocusedOnCenter}
                    />
                  }
                />
                <Route
                  path="/raindrop/settings/payment-methods"
                  element={<RaindropSettingsPaymentMethods />}
                />

                <Route
                  path="/raindrop/playground"
                  element={<RaindropPlayground />}
                />
                <Route
                  path="/raindrop/settings/notifications"
                  element={<RaindropSettingsNotifications />}
                />
                <Route
                  path="/raindrop/tip-add-to-home"
                  element={<RaindropTipAddToHome />}
                />
                <Route
                  path="/raindrop/settings"
                  element={
                    <RaindropSettings
                      userCurrent={userCurrent}
                      setUserCurrent={setUserCurrent}
                      onLogoutRaindrop={onLogoutRaindrop}
                    />
                  }
                />

                <Route
                  path="/raindrop/password-reset"
                  element={<RaindropPasswordReset userCurrent={userCurrent} />}
                />

                <Route
                  path="/raindrop/waterfall-create"
                  element={
                    <RaindropWaterfallCreate
                      userCurrent={userCurrent}
                      values={sausageValues}
                    />
                  }
                />
                <Route
                  path="/raindrop/notifications"
                  element={<RaindropNotifications userCurrent={userCurrent} />}
                />
                <Route
                  path="/raindrop/waterfall/:waterfallId"
                  element={
                    <RaindropWaterfall
                      userCurrent={userCurrent}
                      values={sausageValues}
                      setValues={setValues}
                      onAddNewOrganisation={onAddNewOrganisation}
                      onCancelOrganisation={onCancelOrganisation}
                      setCurrentModalComponent={setCurrentModalComponent}
                    />
                  }
                />
                <Route
                  path="/raindrop/waterfall/:waterfallId/create-post"
                  element={
                    <RaindropWaterfallPostCreate userCurrent={userCurrent} />
                  }
                />
              </Route>

              <Route
                path="/raindrop/auth-test"
                element={
                  <div className="p-2 bg-color-dark-background-tertiary rounded-lg">
                    This is a test authentication page
                  </div>
                }
              />

              <Route
                path="/raindrop/payment-method-add"
                element={<RaindropPaymentMethodAdd userCurrent={userCurrent} />}
              />

              <Route
                path="/raindrop/kindness"
                element={
                  <RaindropKindness
                    values={sausageValues}
                    setCurrentModalComponent={setCurrentModalComponent}
                    setCurrentKindnessAmount={setCurrentKindnessAmount}
                    userCurrent={userCurrent}
                    setUserCurrent={setUserCurrent}
                  />
                }
              />

              <Route
                path="/raindrop/legal/privacy-policy"
                element={<RaindropLegalPrivacyPolicy />}
              />

              <Route
                path="/raindrop/legal/terms-and-conditions"
                element={<RaindropLegalTermsAndConditions />}
              />

              <Route path="/raindrop/welcome" element={<RaindropWelcome />} />
            </Route>

            <Route
              path="/raindrop/entry"
              element={
                <RaindropEntry
                  isDemo={isDemo}
                  setIsDemo={setIsDemo}
                  setUserCurrent={setUserCurrent}
                />
              }
            />

            <Route
              path="/raindrop/login"
              element={<RaindropLogin setUserCurrent={setUserCurrent} />}
            />

            <Route
              path="/raindrop/authenticate"
              element={<RaindropAuthenticate />}
            />

            <Route
              path="/raindrop/under-maintenance"
              element={<div>Under maintenance</div>}
            />
            <Route
              path="/raindrop/sign-up"
              element={
                <RaindropSignUp
                  userCurrent={userCurrent}
                  setUserCurrent={setUserCurrent}
                />
              }
            />

            <Route
              path="/raindrop/tour"
              element={
                <RaindropTour
                  userCurrent={userCurrent}
                  setUserCurrent={setUserCurrent}
                />
              }
            />

            <Route path="/raindrop/*" element={<RaindropNotFound />} />
          </Route>
          {isDomainRaindrop() && (
            <Route path="/" element={<Navigate to="/raindrop/activity" />} />
          )}
        </Route>
      )}

      {(isLocalEnvironment() || isDomainNimbus()) && (
        <Route id={"route-nimbus"} element={<NimbusBase />}>
          <Route path="/nimbus/login" element={<NimbusLogin />} />
          <Route path="/nimbus/authenticate" element={<NimbusAuthenticate />} />
          <Route // authenticated
            id="route-nimbus-authenticated"
            element={
              <NimbusBaseAuthenticated
                currentSupportUser={currentSupportUser}
                setCurrentSupportUser={setCurrentSupportUser}
                currentModalComponent={currentModalComponent}
                setCurrentModalComponent={setCurrentModalComponent}
              />
            }
          >
            {isDomainNimbus() && (
              <Route path="/" element={<Navigate to="/nimbus" />} />
            )}
            <Route path="/nimbus" element={<NimbusHome />} />
            <Route path="/nimbus/quiz" element={<NimbusQuiz />} />
            <Route
              path="/nimbus/cron-jobs/index"
              element={<NimbusCronJobsIndex />}
            />

            <Route
              path="/nimbus/developer-tools/index"
              element={<NimbusDeveloperToolsIndex />}
            />

            <Route
              path="/nimbus/developer-tools/api-hitters"
              element={<NimbusDeveloperToolsAPIHitters />}
            />

            <Route
              path="/nimbus/developer-tools/database"
              element={<NimbusDeveloperToolsDatabase />}
            />
            <Route
              path="/nimbus/developer-tools/emails"
              element={<NimbusDeveloperToolsEmails />}
            />
            <Route
              path="/nimbus/developer-tools/one-off-scripts"
              element={<NimbusDeveloperToolsOneOffScripts />}
            />

            <Route
              path="/nimbus/finance/index"
              element={<NimbusFinanceIndex />}
            />

            <Route
              path="/nimbus/finance/stripe-pricing"
              element={<NimbusFinanceStripePricing />}
            />

            <Route path="/nimbus/home" element={<NimbusHome />} />

            <Route
              path="/nimbus/reset-password"
              element={<NimbusResetPassword />}
            />

            <Route
              path="/nimbus/incidents/index"
              element={<NimbusIncidentsIndex />}
            />
            <Route
              path="/nimbus/incidents/search"
              element={<NimbusIncidentsSearch />}
            />

            <Route
              path="/nimbus/incidents/:incidentId"
              element={<NimbusIncidentsInstance />}
            />

            <Route
              path="/nimbus/sharecards/new"
              element={<NimbusSharecardsNew />}
            />

            <Route path="/nimbus/teams/index" element={<NimbusTeamsIndex />} />

            <Route
              path="/nimbus/teams/review"
              element={<NimbusTeamsReview />}
            />

            <Route
              path="/nimbus/teams/:teamId"
              element={<NimbusTeamsInstance />}
            />

            <Route
              path="/nimbus/users/:userId"
              element={<NimbusUsersInstance />}
            />
            <Route path="/nimbus/users/index" element={<NimbusUsersIndex />} />
            <Route
              path="/nimbus/users/search"
              element={<NimbusUsersSearch />}
            />

            <Route
              path="/nimbus/organisations/index"
              element={<NimbusOrganisationsIndex />}
            />

            <Route
              path="/nimbus/organisation_user/search"
              element={<NimbusOrganisationUserSearch />}
            />

            <Route
              path="/nimbus/organisations/search"
              element={<NimbusOrganisationsSearch />}
            />
            <Route
              path="/nimbus/organisations/new"
              element={<NimbusOrganisationsNew />}
            />

            <Route
              path="/nimbus/organisations/:organisationId"
              element={
                <NimbusOrganisationsInstance
                  setCurrentModalComponent={setCurrentModalComponent}
                />
              }
            />

            <Route path="/nimbus/*" element={<NimbusNotFound />} />
          </Route>
        </Route>
      )}

      {(isLocalEnvironment() || isDomainCirrus()) && (
        <Route id={"route-cirrus"} element={<CirrusBase />}>
          <Route // unauthenticated
            id={"route-cirrus-unauthenticated"}
            element={<CirrusBaseAnonymous />}
          >
            <Route
              path="/cirrus/authenticate"
              element={<CirrusAuthenticate />}
            />
            <Route path="/cirrus/entry" element={<CirrusEntry />} />
            <Route path="/cirrus/login" element={<CirrusLogin />} />
            <Route path="/cirrus/sign-up" element={<CirrusSignUp />} />
          </Route>
          <Route // authenticated
            id={"route-cirrus-authenticated"}
            element={
              <CirrusBaseAuthenticated
                currentOrganisationUser={currentOrganisationUser}
                setCurrentOrganisationUser={setCurrentOrganisationUser}
              />
            }
          >
            {isDomainCirrus() && (
              <Route path="/" element={indexElementCirrus} />
            )}
            <Route path="/cirrus" element={indexElementCirrus} />
            <Route
              path="/cirrus/settings"
              element={
                <CirrusSettings
                  organisation={currentOrganisationUser?.organisation}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route
              path="/cirrus/register-organisation"
              element={
                <CirrusRegisterOrganisation
                  setCurrentOrganisationUser={setCurrentOrganisationUser}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route
              path="/cirrus/activity/new"
              element={
                <CirrusActivityNew
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route path="/cirrus/activity" element={<CirrusActivity />} />
            <Route
              path="/cirrus/donations"
              element={
                <CirrusDonations
                  organisation={currentOrganisationUser?.organisation}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route
              path="/cirrus/description"
              element={
                <CirrusDescription
                  organisation={currentOrganisationUser?.organisation}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route
              path="/cirrus/advertisement/create"
              element={
                <CirrusAdvertisementCreate
                  organisation={currentOrganisationUser?.organisation}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route
              path="/cirrus/advertisements"
              element={<CirrusAdvertisements />}
            />
            <Route
              path="/cirrus/donations/:organisationTransferId"
              element={
                <CirrusDonations
                  organisation={currentOrganisationUser?.organisation}
                  currentOrganisationUser={currentOrganisationUser}
                />
              }
            />
            <Route path="/cirrus/feedback" element={<CirrusFeedback />} />
            <Route path="/cirrus/*" element={<div>Not Found</div>} />
          </Route>
        </Route>
      )}

      {(isLocalEnvironment() || isDomainStratus()) && (
        <Route id={"route-stratus"} element={<StratusBase />}>
          <Route path="/" element={<Navigate to={"/stratus"} />} />

          <Route path={"/stratus"} element={<StratusHome />} />

          <Route path={"/stratus/blog"} element={<StratusBlog />} />
          <Route
            path={"/stratus/blog/:articleSlug"}
            element={<StratusBlog />}
          />

          <Route
            path="/stratus/request-demo"
            element={<StratusRequestDemo />}
          />
          <Route path="/stratus/about-us" element={<StratusAboutUs />} />
          <Route
            path="/stratus/for-organisations"
            element={<StratusOrganisation />}
          />
          <Route
            path="/stratus/legal/terms-and-conditions"
            element={<StratusContactUs />}
          />
          <Route
            path="/stratus/privacy-policy"
            element={<StratusPrivacyPolicy />}
          />
          <Route
            path="/stratus/frequently-asked-questions"
            element={<StratusFrequentlyAskedQuestions />}
          />
          <Route
            path="/stratus/terms-and-conditions"
            element={<StratusTermsAndConditions />}
          />
          <Route path="/stratus/contact-us" element={<StratusContactUs />} />
          <Route path="/stratus/*" element={<StratusNotFound />} />
        </Route>
      )}

      <Route path="*" element={<RaindropNotFound />} />
    </Route>
  );

  return (
    <RouterProvider
      router={createBrowserRouter(createRoutesFromElements(routes))}
    />
  );
}

export default App;
